import { cn } from "@/lib/utils";
import { decodeUserText } from "@/utils/escape";

type Props = {
  value?: string | null;
  className?: string;
  as?: "span" | "p" | "div";
};

/**
 * Renders visitor-submitted text (condolence messages, names, tribute names).
 *
 * The value goes into a text node, so React escapes it for us - no
 * `dangerouslySetInnerHTML`, and nothing a visitor types can become markup.
 * Newlines are preserved with `whitespace-pre-wrap` instead of stored `<br/>`.
 */
const UserText = ({ value, className, as: Tag = "span" }: Props) => (
  <Tag className={cn("whitespace-pre-wrap", className)}>
    {decodeUserText(value)}
  </Tag>
);

export default UserText;
